<template>
  <div
    class="kd-close-btn"
    @click="close"
  >
    {{ GET_TEXT('closeButtonText') }}<img class="kd-close-btn__icon" :src="closeIcon" />
  </div>
</template>

<script>
import * as log from 'loglevel';
import { mapGetters, mapMutations } from 'vuex';
import { GET_TEXT } from '@/store/getter-types';
import { SET_KARTENDESIGNER_VISIBILITY } from '@/store/mutation-types';

export default {
  data() {
    return {
      closeIcon: require('../assets/images/icons/close.svg'),
    };
  },
  computed: {
    ...mapGetters([
      GET_TEXT,
    ]),
  },
  methods: {
    ...mapMutations([
      SET_KARTENDESIGNER_VISIBILITY,
    ]),
    close() {
      log.info('Close clicked');
      this.SET_KARTENDESIGNER_VISIBILITY(false);
      if (window.kartendesigner && window.kartendesigner.onClose) {
        window.kartendesigner.onClose();
      } else {
        log.warn('Could not call function "window.kartendesigner.onClose", because it does not exist.');
      }
    },
  },
};
</script>

<style lang="scss">
.kd-close-btn {
  position: absolute;
  top: 24px;
  right: 30px;
  cursor: pointer;
  z-index: 100;

  &:hover {
    opacity: 0.8;
  }
}

.kd-close-btn__icon {
  width: 16px;
  height: 16px;
  display: inline;
  position: relative;
  top: 3px;
  margin-left: 9px;
}
</style>
